module.exports = __webpack_public_path__ + "static/media/bg-animalwelfare_mb.086f1fe5.jpg";